import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

/**
 * 
 * Pozycja nawigacji
 * 
 */
const NavBarItem = ({ index, url, isActive, isVisible, onClick, children }) => {

    //klasa bazowa css
    const className = "w3-bar-item w3-button w3-padding-large w3-black w3-hover-none w3-hover-text-theme";

    //jesli komponent jest widoczny to go renderujemy
    if (isVisible) {
        return (
            <Link
                to={url}
                className={`${className} ${isActive ? "w3-text-theme" : ""}`}
                onClick={() => onClick(index)}
            >
                {children}
            </Link>)
    } else {
        return null;
    }


};

NavBarItem.propTypes = {
    /**
   * Określa index pozycji Linka - na jego podstawie jest okreslany aktywny Link
   */
    index: PropTypes.number,
    /**
    * Określa url na który przekierowujemy routing
    */
    url: PropTypes.string.isRequired,
    /**
    * Określa czy link jest aktywny. Nie jest wymagane, ponieważ jest to propertka ustawiana automatycznie przez komponent zewnetrzny NavBar
    */
    isActive: PropTypes.bool,
    /**
    * Określa czy link jest widoczny
    */
    isVisible: PropTypes.bool.isRequired,
    /**
    * Określa metodę kliku na element. Nie jest wymagana, ponieważ jest to propertka ustawiana automatycznie przez komponent zewnetrzny NavBar
    */
    onClick: PropTypes.func
};

export default NavBarItem;